import { z } from "zod";

const stringSchema = z.string();

export const parseToString = <T>(target: unknown, defaultValue: T) => {
  const parseResult = stringSchema.safeParse(target);
  return parseResult.success ? parseResult.data : defaultValue;
};
